module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_blue.89f86cf6.png";